import { createClient } from "./requests.js";
let token = "";
// ==================== READ ====================

function getUSPatentApplication(id) {
  const request = createClient(token);
  return request.get(`/application?id=${id}`);
}

function getIssuedPatentMaintenanceData(applId, patentNum) {
  const request = createClient(token);
  return request.get(
    `/application/maintenance?applicationNumber=${applId}&patentNumber=${patentNum}`
  );
}

function getUSPatAppbyCustNum(custnum, start = 0) {
  const request = createClient(token);
  return request
    .get(`/application/customer-number?id=${custnum}&start=${start}`)
    .catch((error) => {
      console.log("error in get pat app by custom " + error);
      return null;
    });
}

function getUSPatentApplicationCmsData(id) {
  const request = createClient(token);
  return request.get(`/application/cmsData?id=${id}`).catch((error) => {
    console.log("error in get cms " + error);
    return null;
  });
}

function getUSPatentApplicationIfwData(id) {
  const request = createClient(token);
  return request.get(`/application/ifw?id=${id}`).catch((error) => {
    console.log("error in get ifw data " + error);
    return null;
  });
}

function downloadDocument(firm_id, applId, docId) {
  const request = createClient(token);
  return request.get(
    `/download/pdf?firm_id=${firm_id}&id=${applId}&docId=${docId}`
  );
}

function downloadDocumentByDownloadUrl(firm_id, applId, downloadUrl) {
  const request = createClient(token);
  return request.post("/download/document", {
    firm_id: firm_id,
    id: applId,
    downloadUrl: downloadUrl,
  });
}

function enqueuePrivatePair(firm_id, customer_number) {
  const request = createClient(token);
  return request.post("/ppair", {
    customer_number: customer_number,
    firm_id: firm_id,
  });
}

function enqueuePrivatePairPatent(firm_id, patent_number) {
  const request = createClient(token);
  return request.post("/ppair", {
    patent_number: patent_number,
    firm_id: firm_id,
  });
}

function sendInvites(firm_id) {
  const request = createClient(token);
  return request.post("/invites/send_invites", {
    firm_id: firm_id,
  });
}

function acceptInvite(invite_id, firm_id) {
  const request = createClient(token);
  return request.post("/invites/accept_invite", {
    invitation_id: invite_id,
    firm_id: firm_id,
  });
}

function countPendingPatents(customer_numbers) {
  const request = createClient(token);
  return request.get("/customerNumberCount", {
    params: { customerNumbers: customer_numbers },
  });
}

function sendXml(firm_id, xml_data) {
  const request = createClient(token);
  return request.post("/xmlImport", { firm_id: firm_id, xml_data: xml_data });
}

function addLLM(firm_id, llm_name, llm_api_key) {
  const request = createClient(token);
  return request.post("/llm-setup/add-llm", {
    firm_id: firm_id,
    llm_name: llm_name,
    llm_api_key: llm_api_key,
  });
}

function deleteLLM(firm_id, llm_name) {
  const request = createClient(token);
  return request.post("/llm-setup/delete-llm", {
    firm_id: firm_id,
    llm_name: llm_name,
  });
}

function getReferencesAndCitations(firm_id, document_id, xml_data) {
  const request = createClient(token);
  return request.post("/office-action/getReferencesAndCitations", {
    firm_id: firm_id,
    document_id: document_id,
    xml_data: xml_data,
  });
}

function generateClaimChart(firm_id, document_id, xml_data) {
  const request = createClient(token);
  return request.post("/office-action/generateClaimChart", {
    firm_id: firm_id,
    document_id: document_id,
    xml_data: xml_data,
  });
}

function getClaimChart(firm_id, document_id) {
  const request = createClient(token);
  return request.get("/office-action/claimChart", {
    params: { firm_id: firm_id, document_id: document_id },
  });
}

function updateClaimChartRow(firm_id, document_id, rowId, updates) {
  const request = createClient(token);
  const body = { firm_id: firm_id, document_id: document_id };
  if (Object.prototype.hasOwnProperty.call(updates, "referenceNumber")) {
    body.referenceNumber = updates.referenceNumber;
  }
  if (Object.prototype.hasOwnProperty.call(updates, "userReview")) {
    body.userReview = updates.userReview;
  }
  return request.patch(
    `/office-action/claimChart/${encodeURIComponent(rowId)}`,
    body
  );
}

function verifyClaimChartCitation(
  firm_id,
  document_id,
  rowId,
  referenceNumber
) {
  const request = createClient(token);
  return request.post(
    `/office-action/claimChart/${encodeURIComponent(rowId)}/verifyCitation`,
    {
      firm_id: firm_id,
      document_id: document_id,
      referenceNumber: referenceNumber,
    }
  );
}

function reverifyClaimChartCitation(
  firm_id,
  document_id,
  rowId,
  referenceNumber,
  disputeNote
) {
  const request = createClient(token);
  return request.post(
    `/office-action/claimChart/${encodeURIComponent(rowId)}/reverifyCitation`,
    {
      firm_id: firm_id,
      document_id: document_id,
      referenceNumber: referenceNumber,
      disputeNote: disputeNote,
    }
  );
}

function draftOAResponse(summary, explanation, firm_id, document_id) {
  const request = createClient(token);
  return request.post("/office-action/analyze", {
    firm_id: firm_id,
    document_id: document_id,
    summary: summary,
    explanation: explanation,
  });
}

function streamOAAnalysis(firm_id, document_id, options = {}) {
  const request = createClient(token);
  return request.postEventStream(
    "/office-action/stream",
    {
      firm_id: firm_id,
      document_id: document_id,
    },
    options
  );
}

function oaChat(
  firm_id,
  document_id,
  chat_history_id,
  user_prompt,
  system_instruction,
  llm_name,
  llm_model,
  context = [],
  options = {}
) {
  const request = createClient(token);
  console.log("Sending OA chat request with context:", context);
  return request.postEventStream(
    "/office-action/chat",
    {
      firm_id: firm_id,
      document_id: document_id,
      session_id: token,
      chat_history_id: chat_history_id,
      user_prompt: user_prompt,
      system_instruction: system_instruction,
      llm_name: llm_name,
      llm_model: llm_model,
      context: context,
    },
    options
  );
}

function parseIdsPdf(firm_id, applId, storagePath) {
  const request = createClient(token);
  return request.post("/ids/parse-ids-pdf", {
    firm_id: firm_id,
    applId: applId,
    storagePath: storagePath,
  });
}

function parseOaPdf(firm_id, applId, file) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("firm_id", firm_id);
  formData.append("applId", applId);
  const request = createClient(token);
  return request.post("/ids/parse-oa-pdf", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

function parseClaimsPdf(firm_id, file) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("firm_id", firm_id);
  const request = createClient(token);
  return request.post("/office-action/parse-claims-pdf", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

function downloadIdsReference(firm_id, reference_id, pdfUrl) {
  const request = createClient(token);
  return request.post("/ids/download-reference", {
    firm_id,
    reference_id,
    pdfUrl,
  });
}

function parseRefPdfs(firm_id, applId, files) {
  const formData = new FormData();
  for (const file of files) {
    formData.append("files", file);
  }
  formData.append("firm_id", firm_id);
  formData.append("applId", applId);
  const request = createClient(token);
  return request.post("/ids/parse-ref-pdfs", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

function lookupReferences(firm_id, applId, referenceNumbers) {
  const request = createClient(token);
  return request.post("/ids/lookup-references", {
    firm_id,
    applId,
    reference_numbers: referenceNumbers,
  });
}

function uploadPriorArtReferences(firm_id, applId, files) {
  const formData = new FormData();
  for (const file of files) {
    formData.append("files", file);
  }
  formData.append("firm_id", firm_id);
  formData.append("applId", applId);
  const request = createClient(token);
  return request.post("/prior-art/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

function scorePriorArtReference(firm_id, applId, reference_id, claims = []) {
  const request = createClient(token);
  return request.post("/prior-art/score", {
    firm_id,
    applId,
    reference_id,
    claims,
  });
}

function generateInvalidationClaimChart(
  firm_id,
  applId,
  primary_reference_id,
  secondary_reference_ids = [],
  invalidation_type = "102",
  claims = []
) {
  const request = createClient(token);
  return request.post("/prior-art/generate-invalidation-chart", {
    firm_id,
    applId,
    primary_reference_id,
    secondary_reference_ids,
    invalidation_type,
    claims,
  });
}

function downloadReference(firm_id, document_id, patent_number) {
  const request = createClient(token);
  return request.post("/office-action/getReferenceByPatentNumber", {
    firm_id: firm_id,
    document_id: document_id,
    patent_number: patent_number,
  });
}

function uploadReferencePdf(firm_id, document_id, reference_id, file) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("firm_id", firm_id);
  formData.append("document_id", document_id);
  formData.append("reference_id", reference_id);
  const request = createClient(token);
  return request.post("/upload/uploadReferencePdf", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

function setAuthToken(id) {
  token = id;
}

// exposes the current ID token for non-axios HTTP layers (rest-firestore)
function getAuthToken() {
  return token;
}

// Patensys v2: currently only changeSubscription is used.
function cancelSubscription(sub_id, firm_id) {
  const request = createClient(token);
  return request.post("/changeSubscription/cancel", {
    subId: sub_id,
    firmId: firm_id,
  });
}

function changeSubscription(sub_id, firm_id, items) {
  const request = createClient(token);
  return request.post("/changeSubscription/change", {
    subId: sub_id,
    firmId: firm_id,
    items: items,
  });
}

function importApplicationById(firm_id, applId) {
  const request = createClient(token);
  return request.post("/publicapplication", {
    firm_id: firm_id,
    application_number: applId,
  });
}

function downloadTmDoc(firm_id, serial_number, doc_id) {
  const request = createClient(token);
  return request.post("/trademark/download-doc", {
    firm_id: firm_id,
    serial_number: serial_number,
    doc_id: doc_id,
  });
}

function importTmDocs(firm_id, serial_number) {
  const request = createClient(token);
  return request.post("/trademark/import-docs", {
    firm_id: firm_id,
    serial_number: serial_number,
  });
}

function addManualFamilyRelation(
  firm_id,
  applIdA,
  applIdB,
  ipOfficeNameA,
  ipOfficeNameB
) {
  const request = createClient(token);
  const body = { firm_id, applIdA, applIdB };
  if (ipOfficeNameA) body.ipOfficeNameA = ipOfficeNameA;
  if (ipOfficeNameB) body.ipOfficeNameB = ipOfficeNameB;
  return request.post("/family-tree/manual-relations", body);
}

function deleteManualFamilyRelation(
  firm_id,
  applIdA,
  applIdB,
  ipOfficeNameA,
  ipOfficeNameB
) {
  const request = createClient(token);
  const body = { firm_id, applIdA, applIdB };
  if (ipOfficeNameA) body.ipOfficeNameA = ipOfficeNameA;
  if (ipOfficeNameB) body.ipOfficeNameB = ipOfficeNameB;
  return request.delete("/family-tree/manual-relations", { data: body });
}

// ==================== litigation module ====================
// Real backend surface (see docs/architecture/litigation-module-plan.md and
// the backend API spec). All under /litigation, auth via `token` header.

// launch-gate probe: is the litigation module enabled for this firm?
// (limited release — backend allowlist; this endpoint itself is ungated)
function litigationEnabled(firm_id) {
  const request = createClient(token);
  return request.get(`/litigation/enabled?firm_id=${firm_id}`);
}

// PACER case metadata lookup (billable). 404 = not found;
// 401 { needsOtp } = PACER session expired for MFA accounts.
function lookupLitigationCase(firm_id, case_number, court) {
  const request = createClient(token);
  return request.get(
    `/litigation/case-lookup?firm_id=${firm_id}&case_number=${encodeURIComponent(
      case_number
    )}&court=${encodeURIComponent(court)}`
  );
}

// TTABVUE proceeding search for the pre-import screen (free — no PACER fees).
// criteria: { attorney, party, serial, proceedingNumber, status, page };
// at least one of attorney/party/serial/proceedingNumber is required.
function searchTtabProceedings(firm_id, criteria = {}) {
  const request = createClient(token);
  const params = new URLSearchParams({ firm_id });
  if (criteria.attorney) params.set("attorney", criteria.attorney);
  if (criteria.party) params.set("party", criteria.party);
  if (criteria.serial) params.set("serial", criteria.serial);
  if (criteria.proceedingNumber)
    params.set("proceeding_number", criteria.proceedingNumber);
  if (criteria.status) params.set("status", criteria.status);
  if (criteria.page) params.set("page", criteria.page);
  return request.get(`/litigation/ttab-search?${params}`);
}

// intake: send complaint PDF, get back an intakeProposal for the prefill
// form. Nothing persisted.
function extractLitigationComplaint(firm_id, file) {
  const request = createClient(token);
  const formData = new FormData();
  formData.append("firm_id", firm_id);
  formData.append("complaint", file);
  return request.post("/litigation/cases/from-complaint", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

// staff PDF upload into the case record. destination "court" ->
// courtDocuments; default -> restrictedDocuments. No share option at upload.
function uploadLitigationDocument(firm_id, case_id, file, title, destination) {
  const request = createClient(token);
  const formData = new FormData();
  formData.append("firm_id", firm_id);
  formData.append("case_id", case_id);
  formData.append("file", file);
  if (title) formData.append("title", title);
  if (destination) formData.append("destination", destination);
  return request.post("/litigation/documents/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

// (re)run DCO/standing-order extraction on a PROCESSED court doc ->
// { proposal }, persisted on the doc (extractionStatus: "proposed")
function extractLitigationDco(firm_id, case_id, document_id, mode = "dco") {
  const request = createClient(token);
  return request.post("/litigation/dco/extract", {
    firm_id,
    case_id,
    document_id,
    mode,
  });
}

// sync DCO extraction: send the PDF directly, get the proposal in the
// response — no Firestore doc needed first, no pipeline race. After staff
// confirm (POST /dco/confirm), attach the PDF for the record separately via
// /documents/upload. Used by the "I have the DCO in hand" upload UX.
// multipart fields: firm_id, case_id, file (the PDF), mode ("dco"|"standing"),
// optional redacted_text (scrub resubmit — re-screened server-side)
function extractLitigationDcoUpload(firm_id, case_id, file, mode = "dco") {
  const request = createClient(token);
  const formData = new FormData();
  formData.append("firm_id", firm_id);
  formData.append("case_id", case_id);
  formData.append("file", file);
  formData.append("mode", mode);
  return request.post("/litigation/dco/extract-upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

// staff confirm the DCO schedule (optionally edited) -> backend creates the
// litigationDocketing tasks from it
function confirmLitigationDco(firm_id, case_id, document_id, proposal) {
  const request = createClient(token);
  return request.post("/litigation/dco/confirm", {
    firm_id,
    case_id,
    document_id,
    ...(proposal ? { proposal } : {}),
  });
}

// staff confirm a standing-order extraction (edited proposal in the body, or
// the persisted one on the doc) -> judge-scoped litigationRuleSets preset
function confirmLitigationStandingOrder(firm_id, case_id, proposal, source_pdf_path = null) {
  const request = createClient(token);
  return request.post("/litigation/standing-orders/confirm", {
    firm_id,
    case_id,
    proposal,
    ...(source_pdf_path ? { source_pdf_path } : {}),
  });
}

// confirm/adjust an auto-generated docketing task (deadline/title optional)
function confirmLitigationTask(firm_id, taskId, adjustments = {}) {
  const request = createClient(token);
  return request.post("/litigation/docketing/confirm", {
    firm_id,
    taskId,
    ...adjustments,
  });
}

// resolved rule table for the case-setup screen (layered merge already done)
function getResolvedRuleSets(firm_id, case_id) {
  const request = createClient(token);
  return request.get(
    `/litigation/rulesets/resolved?firm_id=${firm_id}&case_id=${case_id}`
  );
}

// discovery intake: party-served papers never hit PACER — extract the set
// from the served PDF. ASYNC: parses + screens + persists the upload, starts a
// job-runner extraction (index pass -> batched bilingual item extraction) and
// returns { jobId, totalSubtasks, reused } immediately. The proposal arrives
// via subscribeJob(jobId) as the job's result. A 409 (an extraction already
// running for this case) is NOT an error — it's the attach path.
async function extractLitigationDiscovery(firm_id, case_id, file, redactedText = null, screeningIgnores = null) {
  const request = createClient(token);
  const formData = new FormData();
  formData.append("firm_id", firm_id);
  formData.append("case_id", case_id);
  formData.append("file", file);
  if (redactedText) formData.append("redacted_text", redactedText);
  if (screeningIgnores && screeningIgnores.length) formData.append("screening_ignores", JSON.stringify(screeningIgnores)); // scrub resubmit
  try {
    return await request.post("/litigation/discovery/extract-upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  } catch (e) {
    // 409 = an extraction is already running for this case; attach to it
    if (e.response?.status === 409 && e.response?.data?.jobId)
      return e.response.data;
    throw e;
  }
}

// retry only the FAILED subtasks of a set-extraction job
function retryLitigationSetExtraction(firm_id, case_id, job_id) {
  const request = createClient(token);
  return request.post("/litigation/discovery/extract-upload/retry", {
    firm_id,
    case_id,
    job_id,
  });
}

// the running set-extraction job for a case (if any) — reattach on reopen
function getActiveLitigationSetExtraction(firm_id, case_id) {
  const request = createClient(token);
  return request.get("/litigation/discovery/extract-upload/active", {
    params: { firm_id, case_id },
  });
}

// finished-but-unreviewed extraction work for this case — set splits whose
// proposal was never opened, and responses extractions awaiting confirm/
// discard. The discovery tab surfaces these so the LLM work isn't wasted.
function getLitigationDiscoveryPendingProposals(firm_id, case_id) {
  const request = createClient(token);
  return request.get("/litigation/discovery/pending-proposals", {
    params: { firm_id, case_id },
  });
}

// discard a reviewed-and-rejected SET split — resolves the extraction job so
// the pending-proposals banner stops resurfacing it (nothing was persisted;
// the proposal lived only on the job doc)
function discardLitigationSetProposal(firm_id, case_id, job_id) {
  const request = createClient(token);
  return request.post("/litigation/discovery/discard-set-proposal", {
    firm_id,
    case_id,
    job_id,
  });
}

// IN-FLIGHT extraction jobs for this case (set splits + responses
// extractions) — the discovery tab reattaches their progress on mount
function getLitigationDiscoveryRunningJobs(firm_id, case_id) {
  const request = createClient(token);
  return request.get("/litigation/discovery/running-jobs", {
    params: { firm_id, case_id },
  });
}

// confirm the extracted discovery set -> backend creates one discoveryItems
// doc per request (dedup: existing items in the set are skipped — safe to
// re-confirm). Items start status "open", sharedWithClient false.
// direction is TOP-LEVEL (not inside proposal): "received" | "propounded" —
// who served the set; the extractor's guess can be wrong.
function confirmLitigationDiscovery(
  firm_id,
  case_id,
  proposal,
  direction,
  response_due
) {
  const request = createClient(token);
  return request.post("/litigation/discovery/confirm", {
    firm_id,
    case_id,
    proposal,
    direction,
    ...(response_due ? { response_due } : {}),
  });
}

// step 1 of served-response intake: parse + screen the PDF, persist the text,
// and DETECT the paper's rounds. Returns { paperRounds, sourcePdfPath,
// sourceTextPath }. No body extraction until step 2.
function extractLitigationDiscoveryResponses(firm_id, case_id, set_id, file, redactedText = null, screeningIgnores = null) {
  const request = createClient(token);
  const formData = new FormData();
  formData.append("firm_id", firm_id);
  formData.append("case_id", case_id);
  formData.append("set_id", set_id);
  formData.append("file", file);
  if (redactedText) formData.append("redacted_text", redactedText);
  if (screeningIgnores && screeningIgnores.length) formData.append("screening_ignores", JSON.stringify(screeningIgnores)); // scrub resubmit
  return request.post("/litigation/discovery/extract-responses-upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

// step 2: ASYNC — starts a job-runner extraction over the persisted text for
// the user-selected paper rounds (batches of items, one subtask each) and
// returns { jobId, totalSubtasks, reused } immediately. The proposal +
// extractionId arrive via subscribeJob(jobId); the extraction record is
// persisted unconfirmed when the job completes. A 409 (a job already running
// for this set) is NOT an error — it's the attach path.
async function runLitigationDiscoveryResponsesExtraction(
  firm_id,
  case_id,
  set_id,
  source_text_path,
  paper_rounds,
  selected_rounds,
  source_pdf_path = null,
  selected_item_numbers = null, // [{ itemNumber, paperRound, party }] — item-level pick
  parties = null                // the paper's responding parties (multi-party)
) {
  const request = createClient(token);
  try {
    return await request.post("/litigation/discovery/extract-responses-run", {
      firm_id,
      case_id,
      set_id,
      source_text_path,
      paper_rounds,
      selected_rounds,
      ...(source_pdf_path ? { source_pdf_path } : {}),
      ...(selected_item_numbers ? { selected_item_numbers } : {}),
      ...(parties ? { parties } : {}),
    });
  } catch (e) {
    // 409 = a job is already running for this set; its body carries { jobId, … }
    if (e.response?.status === 409 && e.response?.data?.jobId)
      return e.response.data;
    throw e;
  }
}

// retry only the FAILED subtasks of an extraction job (completed batches are
// untouched)
function retryLitigationResponsesExtraction(firm_id, case_id, job_id) {
  const request = createClient(token);
  return request.post("/litigation/discovery/extract-responses-run/retry", {
    firm_id,
    case_id,
    job_id,
  });
}

// the running extraction job for a set (if any) — reattach after a navigation
function getActiveLitigationResponsesExtraction(firm_id, case_id, set_id) {
  const request = createClient(token);
  return request.get("/litigation/discovery/extract-responses-run/active", {
    params: { firm_id, case_id, set_id },
  });
}

// persist the staff-reviewed responses onto the set's items (appended as
// responseRounds per item; the set records the paper in servedResponses).
// extraction_id ties the confirm to the persisted extraction from step 2;
// draft_round links the paper to an open response draft (closes it as served);
// round_selections maps paper rounds onto existing/new set rounds;
// proposal.supplemental marks an FRCP 26(e) addition.
// unmatched itemNumbers are skipped.
function confirmLitigationDiscoveryResponses(
  firm_id,
  case_id,
  set_id,
  extraction_id,
  { draft_round, round_selections, proposal } = {}
) {
  const request = createClient(token);
  return request.post("/litigation/discovery/confirm-responses", {
    firm_id,
    case_id,
    set_id,
    extraction_id,
    draft_round,
    round_selections,
    proposal,
  });
}

// resume support: the latest response extraction for a set — { extraction },
// null when none. An unconfirmed one is reopened for review instead of
// re-running the (expensive) extraction on a re-upload.
function getLatestLitigationResponseExtraction(firm_id, case_id, set_id) {
  const request = createClient(token);
  return request.get(
    `/litigation/discovery/response-extraction?firm_id=${firm_id}&case_id=${case_id}&set_id=${set_id}`
  );
}

// drop a persisted response extraction without confirming it (staff discarded
// the review) so a later upload doesn't resume it
function discardLitigationResponseExtraction(firm_id, case_id, extraction_id) {
  const request = createClient(token);
  return request.post("/litigation/discovery/response-extraction/discard", {
    firm_id,
    case_id,
    extraction_id,
  });
}

// on-demand ZH translation of a synced served response (extraction is verbatim
// only — no translation in the intake pass). Idempotent: a repeat call returns
// alreadyHad with no second LLM charge.
function translateLitigationItemResponse(firm_id, case_id, item_id) {
  const request = createClient(token);
  return request.post("/litigation/discovery/translate-item-response", {
    firm_id,
    case_id,
    item_id,
  });
}

// LLM-assisted ITERATIVE response drafting for a RECEIVED discovery item (served
// on us). First call (no feedback/current_draft) returns the initial skeleton;
// later calls carry the attorney's feedback + the current working draft (hand
// edits included) and return a revised draft. reference_text = optional
// attorney-attached reference material (protective order, prior response)
// injected as LLM context. Returns { draft, chat } — the working draft and the
// shared staff thread. The draft is never auto-saved as a response; staff
// confirm it via addResponse (propose-then-confirm).
function draftLitigationDiscoveryResponse(
  firm_id,
  case_id,
  item_id,
  feedback = null,
  current_draft = null,
  reference_text = null,
  llm_name = null,
  llm_model = null
) {
  const request = createClient(token);
  return request.post("/litigation/discovery/draft-response", {
    firm_id,
    case_id,
    item_id,
    feedback,
    current_draft,
    ...(reference_text ? { reference_text } : {}),
    ...(llm_name ? { llm_name } : {}),
    ...(llm_model ? { llm_model } : {}),
  });
}

// resume a persisted drafting session: { draft, chat, generalObjections,
// definitions, item } (draft/chat null when never drafted)
function getLitigationDiscoveryDraftState(firm_id, case_id, item_id) {
  const request = createClient(token);
  return request.get("/litigation/discovery/draft-state", {
    params: { firm_id, case_id, item_id },
  });
}

// SET-level objection drafting: general objections (whole-set boilerplate) +
// objections to the DEFINITIONS. Conversational like the item drafter
// (feedback + current_draft steer a revision); the working draft persists on
// the set doc and item drafts inherit generalObjections read-only.
// Returns { generalObjections: [string], definitionObjections: [{term,ground,text}] }.
function draftLitigationDiscoverySetObjections(
  firm_id,
  case_id,
  set_id,
  feedback = null,
  current_draft = null,
  reference_text = null,
  llm_name = null,
  llm_model = null
) {
  const request = createClient(token);
  return request.post("/litigation/discovery/draft-set-objections", {
    firm_id,
    case_id,
    set_id,
    feedback,
    current_draft,
    ...(reference_text ? { reference_text } : {}),
    ...(llm_name ? { llm_name } : {}),
    ...(llm_model ? { llm_model } : {}),
  });
}

// extract the text of an attorney-attached reference document (protective
// order, prior response) so it can be injected into a drafting turn as LLM
// context. Multipart (field "file"); returns { text }. Nothing persists.
function getLitigationDiscoveryReferenceText(firm_id, case_id, file, redactedText = null, screeningIgnores = null) {
  const request = createClient(token);
  const formData = new FormData();
  formData.append("firm_id", firm_id);
  formData.append("case_id", case_id);
  formData.append("file", file);
  if (redactedText) formData.append("redacted_text", redactedText);
  if (screeningIgnores && screeningIgnores.length) formData.append("screening_ignores", JSON.stringify(screeningIgnores)); // scrub resubmit
  return request.post("/litigation/discovery/reference-text", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

// WHOLE-document response drafting for a received set — ASYNC. Starts a job on the
// backend job-runner and returns { jobId, totalSubtasks, reused } immediately; the
// actual draft is delivered by subscribing to the job doc (subscribeJob below).
// A 409 (a job already running for this set) is NOT an error — it's the attach path:
// we return the existing job so the caller subscribes to it.
async function draftLitigationDiscoverySetResponse(
  firm_id,
  case_id,
  set_id,
  feedback = null,
  current_draft = null,
  reference_text = null,
  llm_name = null,
  llm_model = null
) {
  const request = createClient(token);
  try {
    return await request.post("/litigation/discovery/draft-set-response", {
      firm_id,
      case_id,
      set_id,
      feedback,
      current_draft,
      ...(reference_text ? { reference_text } : {}),
      ...(llm_name ? { llm_name } : {}),
      ...(llm_model ? { llm_model } : {}),
    });
  } catch (e) {
    // 409 = a job is already running for this set; its body carries { jobId, … }
    if (e.response?.status === 409 && e.response?.data?.jobId)
      return e.response.data;
    throw e;
  }
}

// retry only the FAILED subtasks of a drafting job (completed batches are untouched)
function retryLitigationDiscoverySetResponse(firm_id, case_id, job_id) {
  const request = createClient(token);
  return request.post("/litigation/discovery/draft-set-response/retry", {
    firm_id,
    case_id,
    job_id,
  });
}

// cancel a running drafting job
function cancelLitigationDiscoverySetResponse(firm_id, case_id, job_id) {
  const request = createClient(token);
  return request.post("/litigation/discovery/draft-set-response/cancel", {
    firm_id,
    case_id,
    job_id,
  });
}

// load the persisted whole-document draft + the source-document paths for the
// workspace's two panes. Returns { responseDraft, responseDraftUpdatedAt, sourcePdfPath, sourceTextPath }.
function getLitigationDiscoverySetResponse(firm_id, case_id, set_id) {
  const request = createClient(token);
  return request.get("/litigation/discovery/set-response", {
    params: { firm_id, case_id, set_id },
  });
}

// pull the docket sheet from PACER, creating one courtDocuments record per
// entry (no PDFs). BILLABLE (~$0.10/page) — the UI confirms first.
// 409 = case has no pacerCaseId (run case-lookup first).
// Returns { created, skipped, total }.
function syncLitigationDocket(firm_id, case_id) {
  const request = createClient(token);
  return request.post("/litigation/sync/docket", { firm_id, case_id });
}

// the ONLY file-read path: returns a short-lived signed URL (audited).
// kind: courtDocument | restrictedDocument | draftVersion | discoveryItem |
// discoverySet | pipelineText; artifact: pdf | translation (for pipelineText)
function downloadLitigationFile(firm_id, case_id, kind, id, extra = {}) {
  const request = createClient(token);
  return request.post("/litigation/download", {
    firm_id,
    case_id,
    kind,
    id,
    ...extra,
  });
}

// staff "fetch from PACER": downloads the entry's PDF via its doc1 id (billable,
// recorded on the doc as fetchCostUsd/fetchBillablePages). No confirmation flow —
// the click is the intent. Returns { storagePath, bytes, fetchCostUsd } or
// { storagePath, alreadyHad: true } when the file was already pulled.
function fetchLitigationDocument(
  firm_id,
  case_id,
  document_id,
  attachment_pacer_doc_id = null,
  process = false
) {
  const request = createClient(token);
  return request.post("/litigation/documents/fetch", {
    firm_id,
    case_id,
    document_id,
    ...(attachment_pacer_doc_id ? { attachment_pacer_doc_id } : {}),
    ...(process ? { process: true } : {}),
  });
}

// on-demand translation for a fetched doc whose pipeline already ran but has no
// translatedTextPath (decided design; endpoint lands with the backend build)
function translateLitigationDocument(
  firm_id,
  case_id,
  document_id,
  attachment_pacer_doc_id = null
) {
  const request = createClient(token);
  return request.post("/litigation/documents/translate", {
    firm_id,
    case_id,
    document_id,
    ...(attachment_pacer_doc_id ? { attachment_pacer_doc_id } : {}),
  });
}

// client-safe text extraction (no classification/proposals) — the mechanical
// first pipeline step; lights up the translate button for a client-fetched doc
// without waiting for staff processing. Idempotent (alreadyHad).
function extractLitigationText(firm_id, case_id, document_id) {
  const request = createClient(token);
  return request.post("/litigation/documents/extract", {
    firm_id,
    case_id,
    document_id,
  });
}

// semantic search over the case's embedded chunks (Stage 1) -> ranked passages
// with document provenance (citation-first; no synthesized answer)
function searchLitigationCase(firm_id, case_id, query, limit = 10) {
  const request = createClient(token);
  return request.post("/litigation/search", { firm_id, case_id, query, limit });
}

// staff confirms a trigger event; the rules engine generates the dependent
// (unconfirmed) deadline tasks — works for case-local trigger slugs too
function confirmLitigationTrigger(firm_id, litigationCaseId, trigger) {
  const request = createClient(token);
  return request.post("/litigation/triggers/confirm", {
    firm_id,
    litigationCaseId,
    ...trigger,
  });
}

// case rule overrides (Rules tab): list / upsert (keyed by ruleId) / delete
function getRuleOverrides(firm_id, case_id) {
  const request = createClient(token);
  return request.get("/litigation/rules/overrides", {
    params: { firm_id, case_id },
  });
}
function upsertRuleOverride(firm_id, case_id, override) {
  const request = createClient(token);
  return request.put("/litigation/rules/overrides", {
    firm_id,
    case_id,
    override,
  });
}
function deleteRuleOverride(firm_id, case_id, ruleId) {
  const request = createClient(token);
  return request.delete("/litigation/rules/overrides", {
    data: { firm_id, case_id, ruleId },
  });
}

// reject a proposed extraction (DCO/order) — clears it from the pending-review
// queue; the doc stays processed
function rejectLitigationExtraction(firm_id, case_id, document_id) {
  const request = createClient(token);
  return request.post("/litigation/dco/reject", {
    firm_id,
    case_id,
    document_id,
  });
}

// ==================== RESPONSE PAPERS (document-first intake) ====================
// a served responses paper stored whole + chat-over-full-text; no per-item
// extraction. Upload is two-step: detect (screen + persist source, then ASYNC
// detection as a job — big papers blew the HTTP ceiling inline) then confirm
// (persist the paper doc with the user-reviewed metadata).

// step 1: screen the paper + persist its source, then start the detection job.
// Returns { jobId, totalSubtasks } — the { meta, coverage, sourcePdfPath,
// sourceTextPath } proposal arrives via subscribeJob(jobId) as the job's
// result. 409 = a detection is already running for this case (attach instead).
// 428 scrub flow. set_id lets the pre-pass map which requests this paper answers.
function uploadLitigationResponsePaper(firm_id, case_id, file, redactedText = null, set_id = null, screeningIgnores = null) {
  const request = createClient(token);
  const formData = new FormData();
  formData.append("firm_id", firm_id);
  formData.append("case_id", case_id);
  formData.append("file", file);
  if (set_id) formData.append("set_id", set_id);
  if (redactedText) formData.append("redacted_text", redactedText);
  if (screeningIgnores && screeningIgnores.length) formData.append("screening_ignores", JSON.stringify(screeningIgnores));
  return request.post("/litigation/discovery/papers/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

// step 2: persist with the user-reviewed metadata (title/roundLabel/servedDate/
// servingParty/setId/direction/coverage are the user's values, not the
// detector's). coverage: [{ itemNumber, kind:"original"|"supplemental" }] from
// the editable picker — which requests this paper answers and as what. Pass
// meta.sourcePdfPath/sourceTextPath from the job result: the detect step
// already persisted the source, so confirm references it instead of re-uploading
// (the file field can be omitted then).
function confirmLitigationResponsePaper(firm_id, case_id, file, meta = {}, redactedText = null, screeningIgnores = null) {
  const request = createClient(token);
  const formData = new FormData();
  formData.append("firm_id", firm_id);
  formData.append("case_id", case_id);
  if (file) formData.append("file", file);
  if (meta.sourcePdfPath) formData.append("source_pdf_path", meta.sourcePdfPath);
  if (meta.sourceTextPath) formData.append("source_text_path", meta.sourceTextPath);
  if (meta.setId) formData.append("set_id", meta.setId);
  if (meta.direction) formData.append("direction", meta.direction);
  if (meta.title) formData.append("title", meta.title);
  if (meta.servedDate) formData.append("served_date", meta.servedDate);
  if (meta.roundLabel) formData.append("round_label", meta.roundLabel);
  if (meta.servingParty) formData.append("serving_party", meta.servingParty);
  if (Array.isArray(meta.coverage) && meta.coverage.length) {
    formData.append("coverage", JSON.stringify(meta.coverage));
  }
  if (redactedText) formData.append("redacted_text", redactedText);
  if (screeningIgnores && screeningIgnores.length) formData.append("screening_ignores", JSON.stringify(screeningIgnores));
  return request.post("/litigation/discovery/papers/confirm", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

function listLitigationResponsePapers(firm_id, case_id) {
  const request = createClient(token);
  return request.get("/litigation/discovery/papers", { params: { firm_id, case_id } });
}

// the SHARED papers' metadata + scrubbed (redacted) text only — the client
// floor. Case clients and case staff both allowed (non-AEO-cleared staff get
// exactly what the client sees).
function listLitigationResponsePapersClient(firm_id, case_id) {
  const request = createClient(token);
  return request.get("/litigation/discovery/papers-client", { params: { firm_id, case_id } });
}

function deleteLitigationResponsePaper(firm_id, case_id, paper_id) {
  const request = createClient(token);
  return request.delete(`/litigation/discovery/papers/${paper_id}`, { params: { firm_id, case_id } });
}

// staff opt-in: share a paper's metadata + scrubbed text with the client
function shareLitigationResponsePaper(firm_id, case_id, paper_id, shared) {
  const request = createClient(token);
  return request.post(`/litigation/discovery/papers/${paper_id}/share`, { firm_id, case_id, shared });
}

function askLitigationResponsePapers(firm_id, case_id, question) {
  const request = createClient(token);
  return request.post("/litigation/discovery/papers/ask", { firm_id, case_id, question });
}

// on-demand ZH translation of a response paper (its 中文 toggle) — idempotent
function translateLitigationResponsePaper(firm_id, case_id, paper_id) {
  const request = createClient(token);
  return request.post(`/litigation/discovery/papers/${paper_id}/translate`, { firm_id, case_id });
}

// on-demand ZH translation of a discovery set's served paper (the 中文 view
// next to the set PDF) — idempotent; returns { translatedTextPath, text }
function translateLitigationDiscoverySet(firm_id, case_id, set_id) {
  const request = createClient(token);
  return request.post(`/litigation/discovery/sets/${set_id}/translate`, { firm_id, case_id });
}

export {
  setAuthToken,
  getAuthToken,
  litigationEnabled,
  lookupLitigationCase,
  searchTtabProceedings,
  extractLitigationComplaint,
  uploadLitigationDocument,
  extractLitigationDco,
  extractLitigationDcoUpload,
  confirmLitigationDco,
  confirmLitigationStandingOrder,
  confirmLitigationTask,
  getResolvedRuleSets,
  extractLitigationDiscovery,
  confirmLitigationDiscovery,
  uploadLitigationResponsePaper,
  confirmLitigationResponsePaper,
  listLitigationResponsePapers,
  listLitigationResponsePapersClient,
  deleteLitigationResponsePaper,
  shareLitigationResponsePaper,
  askLitigationResponsePapers,
  translateLitigationResponsePaper,
  translateLitigationDiscoverySet,
  extractLitigationDiscoveryResponses,
  runLitigationDiscoveryResponsesExtraction,
  retryLitigationResponsesExtraction,
  getActiveLitigationResponsesExtraction,
  retryLitigationSetExtraction,
  getActiveLitigationSetExtraction,
  getLitigationDiscoveryPendingProposals,
  discardLitigationSetProposal,
  getLitigationDiscoveryRunningJobs,
  confirmLitigationDiscoveryResponses,
  getLatestLitigationResponseExtraction,
  discardLitigationResponseExtraction,
  translateLitigationItemResponse,
  draftLitigationDiscoveryResponse,
  getLitigationDiscoveryDraftState,
  draftLitigationDiscoverySetObjections,
  getLitigationDiscoveryReferenceText,
  draftLitigationDiscoverySetResponse,
  retryLitigationDiscoverySetResponse,
  cancelLitigationDiscoverySetResponse,
  getLitigationDiscoverySetResponse,
  syncLitigationDocket,
  downloadLitigationFile,
  fetchLitigationDocument,
  translateLitigationDocument,
  extractLitigationText,
  searchLitigationCase,
  rejectLitigationExtraction,
  confirmLitigationTrigger,
  getRuleOverrides,
  upsertRuleOverride,
  deleteRuleOverride,
  getUSPatentApplication,
  getIssuedPatentMaintenanceData,
  downloadDocument,
  getUSPatAppbyCustNum,
  getUSPatentApplicationCmsData,
  enqueuePrivatePair,
  enqueuePrivatePairPatent,
  getUSPatentApplicationIfwData,
  sendInvites,
  acceptInvite,
  countPendingPatents,
  sendXml,
  downloadDocumentByDownloadUrl,
  getReferencesAndCitations,
  generateClaimChart,
  getClaimChart,
  updateClaimChartRow,
  verifyClaimChartCitation,
  reverifyClaimChartCitation,
  addLLM,
  deleteLLM,
  cancelSubscription,
  changeSubscription,
  draftOAResponse,
  streamOAAnalysis,
  oaChat,
  downloadReference,
  uploadReferencePdf,
  importApplicationById,
  parseIdsPdf,
  parseOaPdf,
  parseClaimsPdf,
  downloadIdsReference,
  parseRefPdfs,
  lookupReferences,
  uploadPriorArtReferences,
  scorePriorArtReference,
  generateInvalidationClaimChart,
  downloadTmDoc,
  importTmDocs,
  addManualFamilyRelation,
  deleteManualFamilyRelation,
};
